import React, { useEffect, useState } from "react";
import Overview from "./Overview";
import OverviewCreator from "./OverviewCreator/OverviewCreator";

export default function RedirectOverview(props) {
  return <>{props?.CurrentRole ? props?.CurrentRole == 1 || props?.CurrentRole == 3 ? <Overview {...props} /> : <OverviewCreator {...props} /> :
    props.authIs ? null : <Overview {...props} />
  }</>;
}
